module.exports = __webpack_public_path__ + "media/images/static/consult/img01-03d2a379c525d490a43910b63bc2efcd.png";